import React from 'react';
import '../styles/processForm.css';

export default function ProcessFormLoading() {
  return <div className="process-form process-form-loading" role="status" aria-live="polite" aria-busy="true">
    <div className="process-loading-heading" aria-hidden="true"><span /><span /></div>
    <div className="process-loading-summary" aria-hidden="true">
      {[0, 1, 2, 3].map(item => <div key={item}><i /><span /></div>)}
    </div>
    <div className="process-loading-fields" aria-hidden="true">
      {[0, 1, 2, 3].map(item => <div key={item}><i /><span /></div>)}
    </div>
    <div className="process-loading-progress" role="progressbar" aria-label="Carregando solicitação"><span /></div>
    <div className="process-loading-status"><span className="process-loading-spinner" aria-hidden="true" /><span>Carregando...</span></div>
  </div>;
}
